import { DateTime } from 'luxon';

export function formatDateSeparator (date: Date): string {
  const dt = DateTime.fromJSDate(date);
  const now = DateTime.now();

  if (dt.hasSame(now, 'day')) {
    return 'Today';
  }

  if (dt.hasSame(now.minus({ days: 1 }), 'day')) {
    return 'Yesterday';
  }

  if (dt.hasSame(now, 'year')) {
    return dt.toLocaleString({ weekday: 'long', month: 'long', day: 'numeric' });
  }

  return dt.toLocaleString({ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}

export function isSameDay (date1: Date, date2: Date): boolean {
  const dt1 = DateTime.fromJSDate(date1);
  const dt2 = DateTime.fromJSDate(date2);

  return dt1.hasSame(dt2, 'day');
}
